var map = {
	"./1_MG_0184-2.webp": "./src/img/brands/AUDI/1_MG_0184-2.webp",
	"./Felicitas_Ernst_audi_advertising1@flxpntx - @gato.tv (132) copy.webp": "./src/img/brands/AUDI/Felicitas_Ernst_audi_advertising1@flxpntx - @gato.tv (132) copy.webp",
	"./MG_0217.webp": "./src/img/brands/AUDI/MG_0217.webp",
	"./_MG_0318 copy.webp": "./src/img/brands/AUDI/_MG_0318 copy.webp",
	"./_MG_0626.webp": "./src/img/brands/AUDI/_MG_0626.webp",
	"./_MG_1431.webp": "./src/img/brands/AUDI/_MG_1431.webp",
	"./_MG_1567.webp": "./src/img/brands/AUDI/_MG_1567.webp",
	"./_MG_9857 copia.webp": "./src/img/brands/AUDI/_MG_9857 copia.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/AUDI sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";